export * from './get-icon-alt-tag';
